/* Main Menu */
var $ = jQuery.noConflict();

$(function(){
    $(document).ready(function() {
		jQuery('.search-results__more').on('click', function () {
			let lm_button = jQuery(this);


			lm_button.find('span').text('Loading...').parent().prop('disabled', true);
			// Here is the ajax stuff.
			jQuery.ajax({
				url: custom_vars.ajax_url, // Here goes our WordPress AJAX endpoint.
				type: 'POST',
				data: {
					action: 'search_load_more',
					nonce: custom_vars.ajax_nonce,
					post_type: lm_button.attr('data-post-type'),
					page: lm_button.attr('data-page'),
					search_query: lm_button.attr('data-query'),
					ppp: lm_button.attr('data-ppp'),
				},

				success: function (response) {
					// Parse JSON response
					var responseData = JSON.parse(response);
					// Check if the response was successful
					if (responseData.success && responseData.html && responseData.total_shown) {
						lm_button.closest('.row').find('.load-more-point').before(responseData.html);
						lm_button.closest('.row').find('.total-shown').html(responseData.total_shown);
						if ( responseData.next_page ) {
							lm_button.attr('data-page', responseData.next_page);
						}

						if ( responseData.last_page ) {
							lm_button.addClass('d-none');
						}
					} else {
						lm_button.addClass('d-none');
					}
				},
				complete: function () {
					lm_button.find('span').text("Load more").parent().prop('disabled', false);
				}
			});
		});

        ///////////////////////////////////////////////////////////////
        // START - Vimeo custom play/pause button for hero blocks only
        var vimeoHeroElement = document.getElementById('vimeoHero');

        if (vimeoHeroElement) {
            var player = new Vimeo.Player(vimeoHeroElement);
    
            $('.play-pause').on('click', function() {
                $('.play-pause').toggleClass('paused');
    
                player.getPaused().then(function(paused) {
                    if (paused) {
                        player.play();
                    } else {
                        player.pause();
                    }
                });
            });
        }
        ////////////////////////////////////////////////////////////
        // END - Vimeo custom play/pause button for hero blocks only

        ///////////////////////////////////////////////////////////////
        // START - Person hero video upload controls
        $('.video-upload-trigger').on('click', function() {
            $(this).hide();
            $(this).closest('.video-wrap').addClass('interacted');
            $(this).closest('.video-wrap').removeClass('loading');
        });

        document.querySelectorAll('.video-upload-trigger').forEach(function (playButton) {
            // Event listener for the custom play button
            playButton.addEventListener("click", function() {
                // Find video tag related to button clicked
                let nextVideoElement = this.nextElementSibling;
        
                if (nextVideoElement.paused == true) {
                    // Play the video
                    nextVideoElement.play();
        
                    // Add active class as video is playing
                    this.classList.add('playing');
                } else {
                    // Pause the video
                    nextVideoElement.pause();
        
                    // Remove active class as video is playing
                    this.classList.remove('playing');
                }
            });
        });
        ////////////////////////////////////////////////////////////
        // END - Person hero video upload controls

        ////////////////////////////////////////////////
        // START - Close desktop menu on click outside
        $(document).click(function(e) {
            if (!$(e.target).is('.navbar-desktop__collapse, .navbar-desktop__collapse *, .search-toggler, .search-toggler *, .navbar-search, .navbar-search *')) {
                $('.navbar-desktop__collapse').collapse('hide');	    
            }
        });
        ////////////////////////////////////////////////
        // END - Close desktop menu on click outside
    });
});

"use strict";

////////////////////////////////////////////////
// START -  mobile nav toggle JS
var navbarToggler = document.querySelector('.navbar-toggler');
var navbarBg = document.querySelector( '.navbar-bg' );
var navBar = document.querySelector( '.navbar' );
var ariaExpanded = navbarToggler.getAttribute( 'aria-expanded' ); 
var headerMain = document.querySelector( '.header-main-menu' );
var pageBody = document.querySelector('body');

navbarToggler.addEventListener( 'click' , function() {

    navBar.classList.toggle( 'is-active' );
    pageBody.classList.toggle('mobile-menu-open');

    if (ariaExpanded == 'true' ) {
        ariaExpanded = 'false'
    } else {
        ariaExpanded = 'true'
    }
    navbarToggler.setAttribute( 'aria-expanded' , ariaExpanded);
});
// END - mobile nav toggle JS
///////////////////////////////////////////////

////////////////////////////////////////////////
// START -  nav toggle search form
var searchToggler = document.querySelector('.search-toggler');
var searchForm = document.querySelector('.navbar-search');

var navbarMobile = document.querySelector('.navbar-mobile');
var navbarDesktop = document.querySelector('.navbar-desktop');
var searchInput = document.querySelector('#nav-search-form'); 

searchToggler.addEventListener( 'click' , function() {
    searchForm.classList.toggle('is-open');
    navbarMobile.classList.toggle('search-active');
    navbarDesktop.classList.toggle('search-active');
	// Check if the search form is open and focus the input if true
	if (searchForm.classList.contains('is-open')) {
		searchInput.focus();
	}
});
////////////////////////////////////////////////
// END -  nav toggle search form

////////////////////////////////////////////////
// START - remove load class from body
// $(window).on('load', function() {
//     // When the page has loaded
//     $('body').removeClass('page-loading');
// });

window.addEventListener('load', function() {
    // When the page has loaded
    document.body.classList.remove('page-loading');
});
// // END - only show focus ring on tab not click
///////////////////////////////////////////////

////////////////////////////////////////////////
// START - only show focus ring on tab not click
function handleFirstTab(e) {
    if (e.keyCode === 9) {
        document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', handleFirstTab);
        window.addEventListener('mousedown', handleMouseDownOnce);
    }
}

function handleMouseDownOnce() {
    document.body.classList.remove('user-is-tabbing');
    window.removeEventListener('mousedown', handleMouseDownOnce);
    window.addEventListener('keydown', handleFirstTab);
}

window.addEventListener('keydown', handleFirstTab);
// END - only show focus ring on tab not click
///////////////////////////////////////////////

document.addEventListener('DOMContentLoaded', function() {
    ///////////////////////////////////////////////////////////////
    // START - add class to show user is scrolling
    var bodyElement = document.body;

    window.addEventListener('scroll', function() {
        if (window.scrollY > 82) {
            document.documentElement.classList.add('is-scrolling');
            bodyElement.classList.add('is-scrolling');
        } else {
            document.documentElement.classList.remove('is-scrolling');
            bodyElement.classList.remove('is-scrolling');
        }
    });
    // END - add class to show user is scrolling
    ///////////////////////////////////////////////////////////////
});


///////////////////////////////////////////////////////////////
// START - get the height of the header and update it on window resize
var headerElement = document.getElementById('header');
var mainMenu = document.querySelector('.header-main');
var mobileMenu = document.getElementById('navbarNavDropdown');
var desktopMenus = document.querySelectorAll('.navbar-desktop__collapse');
var searchBar = document.querySelector('.navbar-search');
var isMobileView = window.innerWidth <= 991;

// Function to get and update the height of the header element and set top position
function updateHeaderHeight() {
    var headerHeight = headerElement.offsetHeight;
    var headerHeightDesk = mainMenu.offsetHeight;

    // Set top position for the mobile menu
    mobileMenu.style.top = `${headerHeight}px`;
    searchBar.style.top = `${headerHeight}px`;

    // Set top position for each desktop menu
    desktopMenus.forEach(function(desktopMenu) {
        desktopMenu.style.top = `${headerHeightDesk}px`;
    });

    // Set top position for search bar on both mobile and desktop
    if (isMobileView) {
        searchBar.style.top = `${headerHeight}px`;
    } else {
        searchBar.style.top = `${headerHeightDesk}px`;
    }
}

// Initial call to set the initial height
updateHeaderHeight();

// Add an event listener for window resize
window.addEventListener('resize', function() {
    var headerHeight = headerElement.offsetHeight;
    var headerHeightDesk = mainMenu.offsetHeight;

    // Update the header height and top position on window resize
    updateHeaderHeight();

    // Reset mobile and desktop position
    if (!isMobileView) {
        searchBar.style.top = `${headerHeightDesk}px`;
    } else {
        searchBar.style.top = `${headerHeight}px`;
    }
});

// show and hide logic for top nav
(function() {
	var header = document.querySelector('.header'),
		// Set the initial scroll position and the threshold for triggering the event
		lastScrollTop = 0,
		delta = 5;

	// Function to handle the scroll event
	function onScroll() {
		// Get the current scroll position
		var nowScrollTop = window.scrollY;
		// Check if the user has scrolled past the threshold
		if(Math.abs(lastScrollTop - nowScrollTop) >= delta){
			// If the user is scrolling down, hide the header
			if (nowScrollTop > lastScrollTop){
				header.classList.add('header-hide');
				header.classList.remove('header-show');
			// If the user is scrolling up, show the header
			} else {
				header.classList.remove('header-hide');
				header.classList.add('header-show');
			}
			// Update the last scroll position
			lastScrollTop = nowScrollTop;
		}
	}

	document.addEventListener("DOMContentLoaded", function() {
		window.addEventListener('scroll', onScroll);
	});
})();
//////////////////////////////////////////////////////////
// END - get the height of the header and update it on window resize

///////////////////////////////////////////////////////////////
// START - play/pause button for ues of the html video element

// Loop through each play/pause video button 
document.querySelectorAll('.video-control:not(.play-pause)').forEach(function (playPauseButton) {
	
	// Event listener for the play/pause button
	playPauseButton.addEventListener("click", function() {
		// Find video tag related to button clicked
		let prevVideoElement = this.previousElementSibling;

		if (prevVideoElement.paused == true) {
			// Play the video
			prevVideoElement.play();

			// Add active class as video is playing
			this.classList.add('playing');
		} else {
			// Pause the video
			prevVideoElement.pause();

			// Remove active class as video is playing
			this.classList.remove('playing');
		}
	});

});

// END - play/pause button for ues of the html video element
///////////////////////////////////////////////////////////////

if (document.querySelector('.tribe-tickets__tickets-item-quantity-number-input')) {
	// Get all elements with the specified class
	var quantityInputs = document.querySelectorAll('.tribe-tickets__tickets-item-quantity-number-input');

	// Loop through each element and set the max attribute to 4
	quantityInputs.forEach(function (input) {
		input.setAttribute('max', '4');
	});
}
